import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User, UserOwner } from '../models/user';

@Injectable({
    providedIn: 'root'
})
export class GeneralStoreService {
    private token: BehaviorSubject<string>;
    private user: BehaviorSubject<User>;
    private menu: BehaviorSubject<any>;
    private selectedOwner: BehaviorSubject<UserOwner>;
    private owners: BehaviorSubject<UserOwner[]>;

    constructor() {
        this.token = new BehaviorSubject<string>(localStorage.getItem('token'));
        this.user = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
        this.menu = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('menu') === 'undefined' ? '[]' : localStorage.getItem('menu')));
        this.selectedOwner = new BehaviorSubject<UserOwner>(JSON.parse(localStorage.getItem('owner')));
        this.owners = new BehaviorSubject<UserOwner[]>(JSON.parse(localStorage.getItem('owners')) || []);
    }

    public getToken(): Observable<string> {
        return this.token.asObservable();
    }

    public getTokenValue(): string {
        return this.token.value;
    }

    public getUser(): Observable<User> {
        return this.user.asObservable();
    }

    public getUserValue(): User {
        return this.user.value;
    }

    public getMenu(): Observable<any> {
        return this.menu.asObservable();
    }

    public getMenuValue(): any {
        return this.menu.value;
    }

    public getOwners(): Observable<UserOwner[]> {
        return this.owners.asObservable();
    }

    public getOwnersValue(): UserOwner[] {
        return this.owners.value;
    }

    public setToken(token: string): void {
        localStorage.setItem('token', token);
        return this.token.next(token);
    }

    public setUser(user: User): void {
        localStorage.setItem('user', JSON.stringify(user));
        return this.user.next(user);
    }

    public setMenu(menu: any): void {
        localStorage.setItem('menu', JSON.stringify(menu));
        return this.menu.next(menu);
    }

    public getSelectedOwner(): Observable<UserOwner> {
        return this.selectedOwner.asObservable();
    }

    public getSelectedOwnerValue(): UserOwner {
        return this.selectedOwner.value;
    }

    public setSelectedOwner(userOwner: UserOwner): void {
        localStorage.setItem('owner', JSON.stringify(userOwner));
        return this.selectedOwner.next(userOwner);
    }

    public setOwners(owners: UserOwner[]): void {
        localStorage.setItem('owners', JSON.stringify(owners));
        return this.owners.next(owners);
    }

    public logout(): void {
        this.setToken('');
        this.setUser(null);
        this.setMenu(null);
        this.setSelectedOwner(null);
        this.setOwners([]);
        localStorage.clear();
    }
}
